import * as React from 'react';
import { Search } from '@weddingspot/ws-api-client';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

import { CventImage } from '@weddingspot/ws-core-components';

const _styles = require('./CuratedBuckets.scss');

interface CardProps {
    data: Search.CuratedBucket;
    handleClick: (bucketLabel: string, url: string) => void;
    isMobile?: boolean;
}

interface CuratedListProps {
    data: Search.CuratedBucket[];
    srpLocation?: Search.LocationDetailed;
    style?: string;
    isMobile?: boolean;
    srpView?: string;
}

const CuratedListCard = (props: CardProps) => {
    const { isMobile, data } = props;
    return (
        <div
            className={_styles.bucketCard}
            onClick={(event) => {
                props.handleClick(data.title, data.url);
            }}
        >
            <a href={data.url.toLowerCase()} target={!isMobile ? '_blank' : '_self'}>
                <CventImage src={data.image} alt={data.title} resize={isMobile ? '150' : '248'} quality={80} />
                <div className={_styles.title}>{data.title}</div>
            </a>
        </div>
    );
};

export const CuratedLists = (props: CuratedListProps) => {
    const { data, style, srpView } = props;
    const srpLocation = props.srpLocation || {};
    const market = srpLocation.market || 'All venues';
    const region = srpLocation.region || null;
    const bucketsListRef = React.useRef<HTMLDivElement>(null);

    const handleCardClick = (curatedListTitle: string) => {
        const eventParams = {
            Market: market,
            Region: region,
            BucketClicked: curatedListTitle,
            ShownBuckets: data.map((item) => item.label),
            Style: style,
            SRPVersion: 2,
            SRPView: srpView,
        };
        logEvent(AnalyticsEvent.EVTNM_CLICKED_VENUE_CURATION_BUCKET, eventParams);
    };

    return (
        <div className={_styles.bucketsList} ref={bucketsListRef}>
            <span className={_styles.listEndSpacer} />
            {data.map((bucket, idx) => {
                return <CuratedListCard key={idx} data={bucket} handleClick={handleCardClick} isMobile={props.isMobile} />;
            })}
            <span className={_styles.listEndSpacer} />
        </div>
    );
};
